module.exports = (count) =>
  if count == 0 then "zero"
  else if count == 1 then "one"
  else "other"



// WEBPACK FOOTER //
// ./resources/locales/locale-data/counting/en.coffee